import script from "./MailExtCompose.vue?vue&type=script&setup=true&lang=js"
export * from "./MailExtCompose.vue?vue&type=script&setup=true&lang=js"

import "./MailExtCompose.vue?vue&type=style&index=0&id=6626f02d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6626f02d"]])

export default __exports__